import * as React from 'react';
import { createDebouncedFunction } from '../../../../../util/useDebounce.js';
import { CAROUSEL_CONSTANTS } from '../constants.js';
import { toggleAriaSlideAttrs } from '../helpers.js';

// Custom hook for carousel event listeners
var useCarouselEventListeners = function useCarouselEventListeners(carouselApi, updateCarouselState, handlePageChange) {
  React.useEffect(function () {
    if (!carouselApi) return undefined;
    var onSelect = function onSelect(api) {
      updateCarouselState(api);
      handlePageChange(api);
    };

    // Initialize state
    updateCarouselState(carouselApi);

    // Set up event listeners
    carouselApi.on('reInit', onSelect);
    carouselApi.on('select', onSelect);
    var debouncedToggleAriaSlideAttrs = createDebouncedFunction(function () {
      return toggleAriaSlideAttrs(carouselApi);
    }, CAROUSEL_CONSTANTS.ARIA_UPDATE_DEBOUNCE_DELAY);
    carouselApi.on('slidesInView', debouncedToggleAriaSlideAttrs);
    return function () {
      carouselApi.off('select', onSelect);
      carouselApi.off('reInit', onSelect);
      carouselApi.off('slidesInView', debouncedToggleAriaSlideAttrs);
    };
  }, [carouselApi, updateCarouselState, handlePageChange]);
};

export { useCarouselEventListeners };
//# sourceMappingURL=useCarouselEventListeners.js.map
